import { FieldsRenderer } from '@neo/blocks/forms/fields-renderer'
import type { GenericFormType } from '@neo/blocks/forms/types'
import { cn } from '@neo/lib/utils'
import { useExternalOrgAppsQuery } from 'v2/pages/settings/integrations/queries'
import { useGenerateFunctionSchemaMutation } from '../../../queries'
import type { AiActionNodeData } from '../../../types'
import { CodeGenerationModal } from '../code-generation-modal-v2'
import { useActionFormConfig } from './action-form-v2.config'
import { MultipleActionsForm } from './multiple-actions.form'

export const ActionsForm = ({
  form,
  nodeVars = [],
  arrayIndex = 0,
}: {
  form: GenericFormType<AiActionNodeData['config']>
  nodeVars?: string[]
  arrayIndex?: number
}) => {
  const { data: activeApps, isLoading: isLoadingApps } = useExternalOrgAppsQuery(true)
  const { mutate: generateFunctionSchema, isPending: isGeneratingFunctionSchema } =
    useGenerateFunctionSchemaMutation()

  const codeName = form.useStore((state) => state.values.actions[arrayIndex]?.code_name)
  const codeDescription = form.useStore(
    (state) => state.values.actions[arrayIndex]?.code_description,
  )
  const hasMultipleActions = form.state.values.actions.length > 1
  const { fields, isCodeGenModalOpen, setIsCodeGenModalOpen } = useActionFormConfig({
    form,
    nodeVars,
    arrayIndex,
    activeApps,
    isLoadingApps,
    generateFunctionSchema,
    isGeneratingFunctionSchema,
  })

  return (
    <div className={cn('w-full max-w-2xl mx-auto', hasMultipleActions && 'editing-sidebar')}>
      {hasMultipleActions ? (
        <MultipleActionsForm form={form} nodeVars={nodeVars} arrayIndex={arrayIndex} />
      ) : (
        <div className=" flex flex-col gap-4">
          <FieldsRenderer
            form={form}
            fields={fields}
            baseName={`actions[${arrayIndex}]`}
            arrayIndex={arrayIndex}
          />
        </div>
      )}
      <CodeGenerationModal
        isOpen={isCodeGenModalOpen}
        onClose={() => setIsCodeGenModalOpen(false)}
        name={codeName || ''}
        description={codeDescription || ''}
        onApply={(code, schema, name, description) => {
          form.setFieldValue(`actions[${arrayIndex}].code_body`, code)
          form.setFieldValue(`actions[${arrayIndex}].code_name`, name)
          form.setFieldValue(`actions[${arrayIndex}].code_description`, description)
          form.setFieldValue(`actions[${arrayIndex}].code_function_schema`, schema)
          form.validateAllFields('change')
        }}
      />
    </div>
  )
}
